module.exports = __webpack_public_path__ + "img/homestead.094d3b83.svg";